<template>
  <div class="w-full pt-16 bg-black text-white" :key="event">
    <!-- Topbar com search -->
    <!-- <header
      class="w-full bg-zinc-950 px-6 py-3 flex justify-center"
    >
      <div class="relative w-full max-w-xl">
        <input
          type="text"
          placeholder="Buscar lutas, eventos ou lutadores"
          class="w-full pl-4 pr-10 py-2 rounded-full bg-zinc-800 text-sm text-white placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-red-600 tracking-wider"
        />
        <div
          class="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-full -mr-3 px-4 bg-gray-700 rounded-e-3xl"
        >
          <div class="h-full flex items-center">
            <PhMagnifyingGlass class="w-5 h-5" />
          </div>
        </div>
      </div>
    </header> -->

    <!-- Grid principal -->
    <div class="container mx-auto px-4 grid grid-cols-1 lg:grid-cols-12 gap-6 mt-5">
      <!-- Coluna esquerda - Player -->
      <div class="lg:col-span-8">
        <!-- Player -->
        <LivePlayer />

        <!-- Informações do vídeo -->
        <div class="mt-2 text-start p-4 pt-0">
          <div class="flex justify-between">
            <div>
              <h1 class="text-3xl tracking-wider font-semibold mb-1">
                {{ event?.title }}
              </h1>

              <div
                class="text-sm text-gray-400 flex flex-wrap gap-2 items-center tracking-wider"
              >
                <span>564 mil visualizações</span>
                <span>•</span>
                <span>
                  {{ formatDate(event?.starts_at) }}
                </span>
              </div>
            </div>

            <!-- Ações -->
            <div class="flex gap-4 mb-6 p-2 tracking-wider rounded-2xl">
              <button class="flex items-center gap-1 hover:opacity-80">
                <PhThumbsUp size="20" />
              </button>
              <button class="flex items-center gap-1 hover:opacity-80">
                <PhThumbsDown size="20" />
              </button>
            </div>
          </div>

          <!-- Descrição -->
          <p class="text-2xl leading-relaxed text-gray-300">
            {{ event?.description }}
          </p>
        </div>

        <!-- Comentários -->
        <!-- <div class="mt-10 p-4">
          <h2 class="text-lg font-semibold mb-4 tracking-wider text-start text-gray-400">
            Comentários
          </h2>
          Aqui entrará um componente de comentários no futuro
          <p class="text-sm text-gray-400 italic">Em breve...</p>
        </div> -->
      </div>

      <!-- Coluna direita - Videos relacionados -->
      <div class="lg:col-span-4 space-y-1" :key="moreEvent">
        <h3 class="text-lg font-berthold-force tracking-wider text-start font-semibold text-white my-2 mb-0 uppercase">
          Veja também
        </h3>
        <LitleCardNotice
          v-for="(item, index) in moreEvent"
          :key="index"
          :title="item?.title"
          :image="item?.banner !== null && item?.banner !== '[]' ? fileUrl + item?.banner : banner"
          :channel="'Number One'"
          :views="'9,7 mil visualizações'"
          :time="formatDate(item?.starts_at)"
          :duration="item?.tag"
          @click="seeOtherEvent(item)"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import LitleCardNotice from '@/shared/components/__partials/LitleCardNotice.vue'
import {
  PhThumbsDown,
  PhThumbsUp
} from '@phosphor-icons/vue'
import { onBeforeMount, watch } from 'vue'
import LivePlayer from '@/shared/components/live/LivePlayer.vue'
import SharedService from '@/shared/services/shared'
import { dataShared } from '@/shared/store'
import { useRoute } from 'vue-router'
import router from '@/router'
import { computed } from 'vue'
import { formatDate } from '@/utils/formaters'
import { showToast as toast } from '@/helpers/UseToasts'
import { ref } from 'vue'

const fileUrl = process.env.VUE_APP_IMAGE_SERVE + 'storage/'
const banner = require('@/assets/logo/icon.png')
const route = useRoute()
const eventId = route.params.eventId
const event = computed(() => dataShared.getters.getEventLiveActivated)
const moreEvent = computed(() => dataShared.getters.getEvents)

async function getEvents () {
  const eventsList = dataShared.getters.getEvents

  if(! eventsList.length)
    await SharedService.getEvents()
      .then(res => {
        dataShared.dispatch('setAllEvents', res.data)
      })
}

async function watchEvent () {
  dataShared.dispatch('activeLoading')

  await SharedService.watchEventById(eventId)
    .then(res => {
      dataShared.dispatch('setEventToPurchase', eventId)
      dataShared.dispatch('desactiveLoading')

      if (res.data.success == false) {
        return router.push(`/purchase/${eventId}/event`)
      }

      dataShared.dispatch('setLiveActive', event.value) 
    }).catch(err => {
      dataShared.dispatch('desactiveLoading')
      console.log(err)
    })
}

async function seeOtherEvent (event) {
  dataShared.dispatch('activeLoading')

  await SharedService.watchEventById(event?.id)
    .then(res => {
      dataShared.dispatch('desactiveLoading')
      dataShared.dispatch('setEventToPurchase', event?.id)
      
      if (res.data.success == false) {
        toast('Aviso', 'Adquira acesso ao evento', 'info')
        return router.push(`/purchase/${event?.id}/event`)
      }

      dataShared.dispatch('setLiveActive', event)
      router.push(`/live/${event?.id}`)
    }).catch(err => {
      console.log(err)
    })
}

onBeforeMount(() => {
  window.scrollTo(0, 0)

  Promise.all([
    watchEvent(),
    getEvents()
  ])

  if (!route.params.eventId) {
    return router.push('/lutas')
  }

})
</script>

<style lang="scss" scoped>
p {
  margin: 10px 0;
}
</style>
